import { render, staticRenderFns } from "./SimpleContainer.vue?vue&type=template&id=167bb390&"
import script from "./SimpleContainer.vue?vue&type=script&lang=js&"
export * from "./SimpleContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports